module.exports = __webpack_public_path__ + "img/breast-feeding.42423774.png";